import type { UseFormRegister } from "react-hook-form"

import type { TTFunction } from "$/i18n/i18n"

import { ETypographySize, TInputProps } from "@/3514/components"
import { EInputVariant } from "@/3514/components/shared/form/input/input.types"

import type {
    TAttendanceModalForm as TForm,
    TAttendanceModalFormRowErrors as TFormRowErrors
} from "./attendance.modal.ui.types"

export default {
    TAG_TITLES_WITH_REQUIRED_FREE_RESPONSE: ["Other"],
    renderFocusInputProps(params: {
        t: TTFunction
        rowIndex: number
        register: UseFormRegister<TForm>
        errors: TFormRowErrors | undefined
        isReserved: boolean
    }): TInputProps {
        return {
            ...params.register(`marks.${params.rowIndex}.focusTagResponse`),
            variant: EInputVariant.White,
            type: "text",
            isRequired: params.isReserved,
            placeholder: params.t("modals.attendance.row.tagSelect.placeholder"),
            textSize: ETypographySize.Small,
            isDisabled: false,
            enterKeyHint: "done",
            isError: !!params.errors?.focusTagResponse,
            errorMessages: params.errors?.focusTagResponse?.message ? [params.errors.focusTagResponse.message] : [],
            withSpelling: true,
            mode: "text",
            inputHeight: "37px",
            maxSymbols: 50
        }
    }
}
